export default __webpack_public_path__ + "static/image-ultraproxy-7e203cb84079c46a3c9986d841aea558.svg";